"use strict";

exports.__esModule = true;
exports.useScroll = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// function throttle (callbackFn, limit) {
//     let wait = false;                  
//     return function () {              
//         if (!wait) {                  
//             callbackFn.call();           
//             wait = true;               
//             setTimeout(function () {  
//                 callbackFn.call();    
//                 wait = false;          
//             }, limit);
//         }
//     }
// }

const useScroll = (tableWrapperRef, tableTopScrollbarRef, tableBottomScrollbarRef) => {
  const [isDown, setIsDown] = _react.default.useState(false);
  const [startX, setStartX] = _react.default.useState(0);
  const [scrollLeft, setScrollLeft] = _react.default.useState(0);
  const dragTimer = _react.default.useRef(null);
  const handleGrab = (e, tableWrapperRef) => {
    const enableDrag = () => {
      setIsDown(true);
      tableWrapperRef.current.classList.add('active');
      setStartX(e.pageX - tableWrapperRef.current.offsetLeft);
      setScrollLeft(tableWrapperRef.current.scrollLeft);
    };
    e.persist();
    if (e.target.classList.contains('uk-datatable__td-inner') && tableWrapperRef.current.scrollWidth >= tableWrapperRef.current.parentElement.scrollWidth) {
      dragTimer.current = window.setTimeout(enableDrag, 500);
    }
  };
  const handleRelease = (e, tableWrapperRef) => {
    window.clearTimeout(dragTimer.current);
    setIsDown(false);
    tableWrapperRef.current.classList.remove('active');
  };
  const handleMove = (e, tableWrapperRef) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tableWrapperRef.current.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    tableWrapperRef.current.scrollLeft = scrollLeft - walk;
  };
  const handleWheel = (e, tableWrapperRef) => {
    if (e.deltaY === 0 && e.deltaX !== 0) {
      tableWrapperRef.current.scrollLeft += e.deltaX;
    }
  };
  _react.default.useEffect(() => {
    const tableTopScrollbar = tableTopScrollbarRef.current;
    const tableBottomScrollbar = tableBottomScrollbarRef.current;
    const tableWrapper = tableWrapperRef.current;
    const updateScrollbars = e => {
      e.preventDefault();
      tableTopScrollbar.scrollLeft = tableWrapper.scrollLeft;
      tableBottomScrollbar.scrollLeft = tableWrapper.scrollLeft;
    };
    const updateWrapperFromTop = () => {
      tableWrapper.scrollLeft = tableTopScrollbar.scrollLeft;
      tableBottomScrollbar.scrollLeft = tableTopScrollbar.scrollLeft;
    };
    const updateWrapperFromBottom = () => {
      tableWrapper.scrollLeft = tableBottomScrollbar.scrollLeft;
      tableTopScrollbar.scrollLeft = tableBottomScrollbar.scrollLeft;
    };
    if (tableWrapper && tableTopScrollbar && tableBottomScrollbar) {
      tableTopScrollbar.addEventListener('scroll', updateWrapperFromTop);
      tableBottomScrollbar.addEventListener('scroll', updateWrapperFromBottom);
      tableWrapper.addEventListener('scroll', updateScrollbars);
    }
    return () => {
      if (tableWrapper && tableTopScrollbar && tableBottomScrollbar) {
        tableTopScrollbar.removeEventListener('scroll', updateWrapperFromTop);
        tableBottomScrollbar.removeEventListener('scroll', updateWrapperFromBottom);
        tableWrapper.removeEventListener('scroll', updateScrollbars);
      }
    };
  }, [tableBottomScrollbarRef, tableTopScrollbarRef, tableWrapperRef]);
  return {
    handleGrab,
    handleRelease,
    handleMove,
    handleWheel
  };
};
exports.useScroll = useScroll;